import React, { useState, useRef, useEffect } from 'react';
import { 
  UploadCloud, Send, FileText, CheckCircle2, Clock, 
  AlertCircle, Filter, Users, X, Play, Pause, Eye,
  FileCheck, AlertTriangle, Phone, MessageCircle, Tag, Database, Building2,
  ChevronLeft, ChevronRight, CalendarDays
} from 'lucide-react';
import api from '../services/api';
import { useLocation, useNavigate } from 'react-router-dom';

// ⭐ NOVO: completa o DDI (55) quando o número da planilha vem só com DDD + número
function normalizePhone(digits) {
  if (!digits) return '';
  if (digits.length === 10 || digits.length === 11) {
    return '55' + digits;
  }
  return digits;
}


function BulkMessaging() {
  const navigate = useNavigate();
  const [campaignName, setCampaignName] = useState('');
  const [sendDelaySeconds, setSendDelaySeconds] = useState(1);
  // ⭐ NOVO: envio intervalado — em vez de um espaçamento único, uma lista de
  // tempos (em segundos) que se repete; opcionalmente embaralhada a cada volta
  const [delayMode, setDelayMode] = useState('fixed'); // 'fixed' | 'pattern'
  const [delayPatternText, setDelayPatternText] = useState('');
  const [delayShuffle, setDelayShuffle] = useState(false);

  // separa por ";", quebra de linha ou vírgula seguida de espaço; vírgula colada
  // entre dígitos (1,5) vale como decimal. Devolve { list (em segundos), error }
  const parseDelayPattern = (text) => {
    const bruto = String(text || '').trim();
    if (!bruto) return { list: [], error: null };
    const tokens = bruto.split(/;|\n|,\s+/).map(t => t.trim()).filter(Boolean);
    const list = [];
    for (const t of tokens) {
      if (!/^\d+([.,]\d+)?$/.test(t)) {
        return { list: [], error: `Valor inválido: "${t}". Use só números, separados por vírgula e espaço ou ponto e vírgula.` };
      }
      const n = Number(t.replace(',', '.'));
      if (n < 1 || n > 3600) {
        return { list: [], error: `"${t}" está fora do limite: cada tempo precisa ficar entre 1 e 3600 segundos.` };
      }
      list.push(n);
    }
    if (list.length > 50) return { list: [], error: 'No máximo 50 tempos.' };
    return { list, error: null };
  };
  const fmtSeg = (n) => `${String(n).replace('.', ',')} s`;
  const fmtDuracao = (seg) => {
    const s = Math.round(seg);
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const r = s % 60;
    if (h > 0) return `${h} h ${m} min`;
    if (m > 0) return r > 0 ? `${m} min ${r} s` : `${m} min`;
    return `${r} s`;
  };
  const delayPatternParsed = delayMode === 'pattern' ? parseDelayPattern(delayPatternText) : { list: [], error: null };
  const [campaignType, setCampaignType] = useState('text'); // 'text' ou 'with_pdfs'
  // ⭐ NOVO: agendar campanha pra depois (igual WATI)
  const [sendMode, setSendMode] = useState('now'); // 'now' ou 'schedule'
  const [scheduledAt, setScheduledAt] = useState(''); // formato 'YYYY-MM-DDTHH:mm', igual antes
  const [showCalendar, setShowCalendar] = useState(false);
  const [calendarMonth, setCalendarMonth] = useState(new Date());
  const [scheduledTime, setScheduledTime] = useState('09:00');

  // ⭐ NOVO: monta a grade de dias do mês (com espaços em branco pro alinhamento)
  const getCalendarDays = (monthDate) => {
    const year = monthDate.getFullYear();
    const month = monthDate.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const startOffset = firstDay.getDay(); // 0 = domingo
    const days = [];
    for (let i = 0; i < startOffset; i++) days.push(null);
    for (let d = 1; d <= lastDay.getDate(); d++) days.push(new Date(year, month, d));
    return days;
  };

  const selectCalendarDay = (day) => {
    if (!day) return;
    const yyyy = day.getFullYear();
    const mm = String(day.getMonth() + 1).padStart(2, '0');
    const dd = String(day.getDate()).padStart(2, '0');
    setScheduledAt(`${yyyy}-${mm}-${dd}T${scheduledTime}`);
  };

  const updateScheduledTime = (newTime) => {
    setScheduledTime(newTime);
    // ⭐ CORRIGIDO: antes, mudar só o horário sem clicar num dia não fazia nada
    // (a data ficava vazia por baixo dos panos). Agora assume "hoje" nesse caso.
    const datePart = scheduledAt ? scheduledAt.split('T')[0] : (() => {
      const now = new Date();
      return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    })();
    setScheduledAt(`${datePart}T${newTime}`);
  };

  const formatScheduledDisplay = () => {
    if (!scheduledAt) return 'Selecionar data e hora';
    const [datePart, timePart] = scheduledAt.split('T');
    const [yyyy, mm, dd] = datePart.split('-');
    return `${dd}/${mm}/${yyyy} às ${timePart}`;
  };
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [templateList, setTemplateList] = useState([]);
  const [selectedTemplateData, setSelectedTemplateData] = useState(null);
  const [csvFile, setCsvFile] = useState(null);
  const [recipients, setRecipients] = useState([]);
  const [tags, setTags] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [allUsers, setAllUsers] = useState([]); // ⭐ NOVO: pra escolher atendentes específicos da campanha
  const [selectedAttendants, setSelectedAttendants] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedSector, setSelectedSector] = useState('');
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  // NOVO: quando o setor tem mais de um número, permite escolher qual usar
  const [selectedPhoneNumberId, setSelectedPhoneNumberId] = useState('');

  // NOVO: todos os números vinculados ao setor escolhido (pode ser mais de um)
  const numbersOfSelectedSector = selectedSector
    ? phoneNumbers.filter(n => String(n.sector_id) === String(selectedSector))
    : [];

  // ⭐ CORRIGIDO: quando um setor é escolhido, só mostra templates aprovados pro WABA
  // daquele número. Se o setor ainda não tem número vinculado, mostra vazio (não a
  // lista toda) — antes isso "vazava" templates de outros setores por engano.
  // NOVO: se o setor tem mais de um número, usa o que foi escolhido explicitamente
  // no dropdown; se só tem um, usa ele direto (sem precisar escolher)
  const numberForSelectedSector = selectedPhoneNumberId
    ? numbersOfSelectedSector.find(n => String(n.phone_number_id) === String(selectedPhoneNumberId))
    : (numbersOfSelectedSector.length === 1 ? numbersOfSelectedSector[0] : null);
  const filteredTemplateList = (() => {
    const approved = templateList.filter(t => t.status !== 'deleted' && !t.is_archived);
    // ⭐ CORRIGIDO: antes, com "Todos os setores" selecionado, mostrava TODO
    // template aprovado sem checar se o número dono dele ainda está conectado —
    // um template de um WABA removido/trocado continuava aparecendo pra sempre.
    // Agora só mostra template cujo waba_id bate com algum número ativo no sistema.
    const connectedWabaIds = new Set(phoneNumbers.map(n => n.waba_id).filter(Boolean));
    const withActiveNumber = approved.filter(t => connectedWabaIds.has(t.waba_id));
    if (!selectedSector) return withActiveNumber;
    if (numbersOfSelectedSector.length > 1 && !selectedPhoneNumberId) return []; // precisa escolher o número primeiro
    if (!numberForSelectedSector || !numberForSelectedSector.waba_id) return [];
    return withActiveNumber.filter(t => t.waba_id === numberForSelectedSector.waba_id);
  })();
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [loadingContacts, setLoadingContacts] = useState(false);
  const [sending, setSending] = useState(false);
  const [preview, setPreview] = useState('');
  const [pdfFiles, setPdfFiles] = useState([]);
  const [pdfUploadResult, setPdfUploadResult] = useState(null);
  const [matchResult, setMatchResult] = useState(null);
  const [createdCampaignId, setCreatedCampaignId] = useState(null);
  const fileInputRef = useRef(null);
  const pdfInputRef = useRef(null);
const [templateVariables, setTemplateVariables] = useState([]);
const [variableMapping, setVariableMapping] = useState({}); // { variavel: coluna_csv }
const [csvHeaders, setCsvHeaders] = useState([]);
const location = useLocation();


// Receber contatos selecionados da tela de Contatos
useEffect(() => {
  if (location.state?.preSelectedContacts) {
    const preSelected = location.state.preSelectedContacts;
    
    // Criar CSV automaticamente com os contatos selecionados
    const csvContent = preSelected.map(c => `${c.wa_id},${c.profile_name || ''}`).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const file = new File([blob], 'contatos_selecionados.csv', { type: 'text/csv' });
    
    setCsvFile(file);
    
    // Processar recipients
    const recipients = preSelected.map(c => ({
      phone: c.wa_id,
      name: c.profile_name || '',
      cpf: ''
    }));
    
    setRecipients(recipients);
    
    // Limpar state para não reaparecer se recarregar
    window.history.replaceState({}, document.title);
  }
}, [location.state]);




  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      const [templatesRes, tagsRes, sectorsRes, numbersRes, usersRes] = await Promise.all([
        api.get('/api/templates'),
        api.get('/api/tags'),
        api.get('/api/sectors'),
        api.get('/api/phone-numbers'),
        api.get('/api/users')
      ]);
      setTemplateList(templatesRes.data);
      setTags(tagsRes.data);
      setSectors(sectorsRes.data);
      setPhoneNumbers(numbersRes.data); // ⭐ NOVO: usado pra filtrar templates pelo WABA do setor
      setAllUsers(usersRes.data);
    } catch (err) {
      console.error('Erro ao carregar dados:', err);
    }
  };

  useEffect(() => {
  const loadTemplateVariables = async () => {
    try {
      const res = await api.get('/api/template-variables');
      setTemplateVariables(res.data);
    } catch (err) {
      console.error('Erro ao carregar variáveis:', err);
    }
  };
  loadTemplateVariables();
}, []);


  

  useEffect(() => {
    if (selectedTemplate) {
      const template = templateList.find(t => t.id.toString() === selectedTemplate);
      setSelectedTemplateData(template);
      updatePreview(template);
    } else {
      setSelectedTemplateData(null);
      setPreview('');
    }
  }, [selectedTemplate, templateList]);

  // ⭐ CORRIGIDO: lê o texto real do corpo/rodapé a partir de template.components
  // (a tabela templates guarda o conteúdo como JSON no formato da Meta, não em
  // colunas soltas body/header/footer)
  const updatePreview = (template) => {
    if (!template) return;
    const components = template.components || [];
    const bodyComp = components.find(c => c.type === 'BODY');
    const headerTextComp = components.find(c => c.type === 'HEADER' && c.format === 'TEXT');
    const footerComp = components.find(c => c.type === 'FOOTER');

    let text = bodyComp?.text || '';
    text = text.replace(/\{\{1\}\}/g, 'João');
    text = text.replace(/\{\{2\}\}/g, '123');
    if (headerTextComp?.text) text = headerTextComp.text + '\n\n' + text;
    if (footerComp?.text) text = text + '\n\n' + footerComp.text;
    setPreview(text);
  };

  const handleFileChange = (e) => {
  const file = e.target.files[0];
  setCsvFile(file);
  if (file) {
    const reader = new FileReader();
    reader.onload = (evt) => {
      // ⭐ NOVO: detecta a codificação certa do arquivo — tenta UTF-8 primeiro,
      // e se não for válido, assume Windows-1252 (comum em CSV exportado
      // pelo Excel em português, que corrompia acentos tipo "Antônio")
      const buffer = evt.target.result;
      let text;
      try {
        text = new TextDecoder('utf-8', { fatal: true }).decode(buffer);
      } catch (err) {
        text = new TextDecoder('windows-1252').decode(buffer);
      }
      const lines = text.split('\n').filter(line => line.trim() !== '');
      console.log('[DEBUG] Total de linhas no arquivo (com cabecalho):', lines.length);

      if (lines.length === 0) return;

      // ⭐ NOVO: detecta se a planilha usa vírgula ou ponto-e-vírgula como separador
      // (Excel em português normalmente exporta com ; porque , é separador decimal aqui)
      const commaCount = (lines[0].match(/,/g) || []).length;
      const semicolonCount = (lines[0].match(/;/g) || []).length;
      const delimiter = semicolonCount > commaCount ? ';' : ',';

      const headers = lines[0].split(delimiter).map(h => h.trim());
      setCsvHeaders(headers);

      // ⭐ NOVO: acha a coluna certa pelo NOME do cabeçalho, não pela posição fixa —
      // assim funciona independente da ordem das colunas na planilha
      const normalize = (s) => s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const findColIndex = (candidates) => headers.findIndex(h => candidates.includes(normalize(h)));

      const phoneIdx = findColIndex(['telefone', 'phone', 'celular', 'whatsapp', 'numero']);
      const nameIdx = findColIndex(['nome', 'name']);
      const cpfIdx = findColIndex(['cpf']);

      // Processar dados
      // Processar dados
      const data = lines.slice(1).map(line => {
        const cols = line.split(delimiter).map(c => c.trim());
        const rowData = {};
        headers.forEach((header, idx) => {
          rowData[header] = cols[idx] || '';
        });

        return {
          phone: normalizePhone((phoneIdx >= 0 ? cols[phoneIdx] : cols[0])?.replace(/\D/g, '') || ''),
          name: (nameIdx >= 0 ? cols[nameIdx] : cols[1]) || '',
          cpf: (cpfIdx >= 0 ? cols[cpfIdx] : cols[2]) || '',
          ...rowData // Incluir todas as colunas
        };
      });
      console.log('[DEBUG] Linhas processadas antes do filtro de telefone:', data.length);
      const filteredData = data.filter(r => r.phone);
      console.log('[DEBUG] Linhas com telefone valido (final):', filteredData.length);
      console.log('[DEBUG] Amostra das 5 primeiras linhas DESCARTADAS (sem telefone):', data.filter(r => !r.phone).slice(0, 5));

      setRecipients(filteredData);
    };
        reader.readAsArrayBuffer(file);
  }
};
  const handlePdfChange = (e) => {
    const files = Array.from(e.target.files);
    setPdfFiles(files);
  };

  const toggleTag = (tagId) => {
    setSelectedTags(prev => 
      prev.includes(tagId) ? prev.filter(t => t !== tagId) : [...prev, tagId]
    );
  };

  // ⭐ CORRIGIDO: campanha com boletos conta só o CSV (precisa de CPF); campanha de
  // texto simples pode somar destinatários vindos do filtro de setor/tag também
  // ⭐ CORRIGIDO: destinatários vêm sempre do CSV, nunca de contatos filtrados por setor
  const totalRecipients = recipients.length;


  // ⭐ NOVO: quantas variáveis {{n}} o corpo do template selecionado usa
  const getPlaceholderCount = (template) => {
    if (!template) return 0;
    const bodyComponent = (template.components || []).find(c => c.type === 'BODY');
    const bodyText = bodyComponent?.text || '';
    const matches = [...bodyText.matchAll(/\{\{(\d+)\}\}/g)];
    return matches.length > 0 ? Math.max(...matches.map(m => parseInt(m[1]))) : 0;
  };

  // ⭐ NOVO: lista de variáveis pra mapear. Usa nomes cadastrados quando o template
  // tem esse vínculo salvo (variable_mapping); senão, cai pra mapeamento por posição
  // ({{1}}, {{2}}, {{3}}...) — cobre templates sincronizados direto da Meta.
  const mappingVariables = (() => {
    if (!selectedTemplateData) return [];
    const count = getPlaceholderCount(selectedTemplateData);
    if (count === 0) return [];
    const namedMapping = selectedTemplateData.variable_mapping;
    if (Array.isArray(namedMapping) && namedMapping.length === count) {
      return namedMapping.map((varName, idx) => {
        const known = templateVariables.find(v => v.name === varName);
        return known || { id: `pos-${idx + 1}`, name: varName, description: `Posição {{${idx + 1}}}` };
      });
    }
    return Array.from({ length: count }, (_, idx) => ({
      id: `pos-${idx + 1}`,
      name: String(idx + 1),
      description: `Variável de posição {{${idx + 1}}} no corpo da mensagem`
    }));
  })();

  const autoMapVariables = () => {
  const newMapping = {};
  
  mappingVariables.forEach(variable => {
    // ⭐ NOVO: pra variável de posição, procura antes uma coluna chamada exatamente {{n}}
    const exactPositional = csvHeaders.find(header => header.trim() === `{{${variable.name}}}`);
    // Tentar encontrar coluna correspondente no CSV
    const matchingHeader = exactPositional || csvHeaders.find(header => {
      const headerLower = header.toLowerCase();
      const varNameLower = variable.name.toLowerCase();
      
      // Verificar se o nome da variável está no header
      return headerLower.includes(varNameLower) || 
             varNameLower.includes(headerLower) ||
             // Mapeamentos comuns
             (varNameLower === 'nome_cliente' && headerLower.includes('nome')) ||
             (varNameLower === 'cpf_cliente' && headerLower.includes('cpf')) ||
             (varNameLower === 'telefone_cliente' && headerLower.includes('telefone'));
    });
    
    if (matchingHeader) {
      newMapping[variable.name] = matchingHeader;
    }
  });
  
  setVariableMapping(newMapping);
  alert(`✅ ${Object.keys(newMapping).length} variáveis mapeadas automaticamente!`);
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!campaignName.trim()) {
      alert('Digite o nome da campanha');
      return;
    }
    if (!selectedTemplate) {
      alert('Selecione um template');
      return;
    }
    // ⭐ CORRIGIDO: valida o agendamento ANTES de criar a campanha — evita
    // ficar um rascunho "fantasma" no banco quando a validação falha
    if (sendMode === 'schedule' && !scheduledAt) {
      alert('Escolha a data e hora do agendamento (clique num dia no calendário)');
      return;
    }
    if (totalRecipients === 0) {
      alert('Defina os destinatários');
      return;
    }

    // ⭐ NOVO: envio intervalado — confere os tempos ANTES de criar a campanha
    if (delayMode === 'pattern') {
      if (delayPatternParsed.error) {
        alert('Confira os intervalos: ' + delayPatternParsed.error);
        return;
      }
      if (delayPatternParsed.list.length < 2) {
        alert('Envio intervalado: informe pelo menos 2 tempos (em segundos).');
        return;
      }
    }

    if (!window.confirm(`Iniciar campanha "${campaignName}" para ${totalRecipients} destinatários?`)) return;

    setSending(true);
   try {
    // Processar recipients com mapeamento de variáveis
    const processedRecipients = recipients.map(r => {
      const contactData = {};
      
      // Mapear variáveis
      Object.entries(variableMapping).forEach(([varName, csvColumn]) => {
        if (csvColumn && r[csvColumn]) {
          contactData[varName] = r[csvColumn];
        }
      });
      
      return {
        wa_id: r.phone,
        name: r.name,
        cpf: r.cpf,
        contact_data: contactData // ⭐ NOVO: dados para variáveis
      };
    });
    
    const campaignData = {
      name: campaignName,
      template_id: parseInt(selectedTemplate),
      sector_id: selectedSector ? parseInt(selectedSector) : null,
      phone_number_id: numberForSelectedSector ? numberForSelectedSector.phone_number_id : null, // NOVO
      attendant_ids: selectedAttendants, // ⭐ NOVO: atendentes específicos escolhidos pra essa campanha
      tag_ids: selectedTags,
      campaign_type: campaignType,
      recipients: processedRecipients,
      variable_mapping: variableMapping,
      send_delay_ms: Math.round(sendDelaySeconds * 1000),
      send_delay_pattern: delayMode === 'pattern' ? delayPatternParsed.list.map(s => Math.round(s * 1000)) : null,
      send_delay_shuffle: delayMode === 'pattern' ? delayShuffle : false // ⭐ NOVO: enviar mapeamento
    };

      const createRes = await api.post('/api/campaigns', campaignData);
      const campaignId = createRes.data.id;

      // ⭐ NOVO: confere se o servidor GUARDOU o padrão de intervalos. Um backend
      // de versão anterior ignora o campo e a campanha sairia com intervalo fixo —
      // melhor parar aqui do que enviar diferente do combinado.
      if (delayMode === 'pattern' && !(Array.isArray(createRes.data.send_delay_pattern) && createRes.data.send_delay_pattern.length > 0)) {
        let apagou = false;
        try {
          await api.delete(`/api/campaigns/${campaignId}`);
          apagou = true;
        } catch (delErr) {
          console.error('Erro ao apagar rascunho:', delErr);
        }
        alert('O servidor não guardou o padrão de intervalos (o backend provavelmente ainda não foi atualizado), então a campanha NÃO foi iniciada.' + (apagou ? ' O rascunho criado foi apagado.' : ' Um rascunho ficou criado — apague-o na lista de campanhas.'));
        setSending(false);
        return;
      }
      setCreatedCampaignId(campaignId);

      // Se tem PDFs, fazer upload
      if (campaignType === 'with_pdfs' && pdfFiles.length > 0) {
        const formData = new FormData();
        pdfFiles.forEach(file => formData.append('files', file));

        const uploadRes = await api.post(`/api/campaigns/${campaignId}/pdfs`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        setPdfUploadResult(uploadRes.data);

        // Fazer conferência automática
        const matchRes = await api.post(`/api/campaigns/${campaignId}/match`);
        setMatchResult(matchRes.data);
      }

      // ⭐ NOVO: agenda pra depois, ou inicia o envio agora mesmo
      if (sendMode === 'schedule') {
        if (!scheduledAt) {
          alert('Escolha a data e hora do agendamento');
          setSending(false);
          return;
        }
        // ⭐ CORRIGIDO: converte o horário escolhido (no fuso do navegador, ex:
        // Brasília) pra um instante UTC sem ambiguidade, antes de mandar pro
        // servidor — evita o bug de "data já passou" causado por fuso horário
        const [datePart, timePart] = scheduledAt.split('T');
        const [yyyy, mm, dd] = datePart.split('-').map(Number);
        const [hh, min] = timePart.split(':').map(Number);
        const scheduledDateLocal = new Date(yyyy, mm - 1, dd, hh, min);
        await api.put(`/api/campaigns/${campaignId}/schedule`, { scheduled_at: scheduledDateLocal.toISOString() });
        alert(`✅ Campanha agendada com sucesso para ${new Date(scheduledAt).toLocaleString('pt-BR')}!`);
      } else {
        await api.post(`/api/campaigns/${campaignId}/launch`);
        alert(`✅ Campanha iniciada com sucesso!`);
      }

      // Resetar
      setCampaignName('');
      setSelectedTemplate('');
      setCsvFile(null);
      setRecipients([]);
      setPdfFiles([]);
      setSelectedTags([]);
      setSelectedSector('');
      setCampaignType('text');
      setSendMode('now');
      setScheduledAt('');

      // ⭐ NOVO: vai direto pra tela de acompanhamento de campanhas
      navigate('/campaigns');
      
    } catch (err) {
      console.error('Erro:', err);
      alert('Erro: ' + (err.response?.data?.error || err.message));
    } finally {
      setSending(false);
    }
  };

return (
  <div className="space-y-6">
    <div>
      <h1 className="text-2xl font-bold text-gray-900">Disparo em Massa</h1>
      <p className="text-gray-500">Campanhas escaláveis com segmentação inteligente</p>
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-7 gap-6">
      {/* Coluna Esquerda: Configurações */}
      <div className="lg:col-span-4 space-y-6">
        
        {/* Tipo de Campanha */}
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6">
          <h2 className="text-lg font-bold mb-4">Tipo de Campanha</h2>
          <div className="grid grid-cols-2 gap-4">
            <button
              type="button"
              onClick={() => setCampaignType('text')}
              className={`p-4 border-2 rounded-xl text-left transition-all ${
                campaignType === 'text'
                  ? 'border-green-500 bg-green-50'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <div className="flex items-center gap-2">
                <p className="font-bold">Campanha Normal</p>
                <FileText size={24} className={campaignType === 'text' ? 'text-green-600' : 'text-gray-400'} />
              </div>
              <p className="text-xs text-gray-600 mt-1">Apenas mensagem de texto via template</p>
            </button>
            <button
              type="button"
              onClick={() => setCampaignType('with_pdfs')}
              className={`p-4 border-2 rounded-xl text-left transition-all ${
                campaignType === 'with_pdfs'
                  ? 'border-purple-500 bg-purple-50'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <div className="flex items-center gap-2">
                <p className="font-bold">Com Boletos</p>
                <FileCheck size={24} className={campaignType === 'with_pdfs' ? 'text-purple-600' : 'text-gray-400'} />
              </div>
              <p className="text-xs text-gray-600 mt-1">Template + PDF anexado para cada cliente</p>
            </button>
          </div>
        </div>

        {/* Informações da Campanha */}
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 space-y-6">
          <h2 className="text-lg font-bold flex items-center gap-2">
            <FileText size={20} className="text-green-600"/> 
            Informações da Campanha
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
            <div className="md:col-span-3">
              <label className="block text-sm font-medium mb-1">Nome da Campanha *</label>
              <input 
                type="text" 
                value={campaignName} 
                onChange={e => setCampaignName(e.target.value)}
                className="w-full p-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-green-500 outline-none" 
                placeholder="Ex: Promoção Maio" 
              />
            </div>

            {/* ⭐ NOVO: espaçamento entre envios — ajusta sozinho pra cima se a
                qualidade do número ou a taxa de falha piorarem durante o envio */}
            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-1 whitespace-nowrap">Espaçamento (s)</label>
              <input
                type="number"
                min="1"
                step="0.5"
                value={sendDelaySeconds}
                disabled={delayMode === 'pattern'}
                onChange={e => setSendDelaySeconds(Math.max(1, parseFloat(e.target.value) || 1))}
                className="w-full p-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-green-500 outline-none"
                title="Tempo de espera entre cada envio. Aumenta sozinho se a taxa de falha subir durante o disparo."
              />
              <label className="mt-1.5 flex items-center gap-1.5 text-xs text-gray-600 dark:text-slate-300 cursor-pointer">
                <input
                  type="checkbox"
                  checked={delayMode === 'pattern'}
                  onChange={e => setDelayMode(e.target.checked ? 'pattern' : 'fixed')}
                  className="accent-green-600"
                />
                Intervalado
              </label>
            </div>

            {/* ⭐ NOVO: Setor movido pra cá — define qual número/WABA envia e filtra o template abaixo.
                Coluna mais larga (5/12) que as outras pra caber o número de telefone inteiro. */}
            <div className="md:col-span-5">
              <label className="text-sm font-medium mb-1 flex items-center gap-1.5">
                <Building2 size={14} className="text-gray-400" />
                Filtrar por Setor
              </label>
              <select 
                value={selectedSector && selectedPhoneNumberId ? `${selectedSector}::${selectedPhoneNumberId}` : selectedSector}
                onChange={e => {
                  const val = e.target.value;
                  if (!val) {
                    setSelectedSector('');
                    setSelectedPhoneNumberId('');
                  } else {
                    const [sectorId, phoneId] = val.split('::');
                    setSelectedSector(sectorId);
                    setSelectedPhoneNumberId(phoneId || '');
                  }
                  setSelectedTemplate('');
                }}
                className="w-full p-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-green-500 outline-none">
                <option value="">Todos os setores</option>
                {/* ⭐ CORRIGIDO: antes, setor com mais de um número abria um segundo
                    dropdown pra escolher qual — agora cada combinação setor+número
                    já aparece como uma opção própria, direto na mesma lista */}
                {sectors.flatMap(s => {
                  const numbersOfSector = phoneNumbers.filter(n => String(n.sector_id) === String(s.id));
                  if (numbersOfSector.length === 0) {
                    return [<option key={s.id} value={s.id}>{s.name}</option>];
                  }
                  return numbersOfSector.map(n => (
                    <option key={`${s.id}-${n.phone_number_id}`} value={`${s.id}::${n.phone_number_id}`}>
                      {s.name}  {n.display_phone_number || n.phone_number}
                    </option>
                  ));
                })}
              </select>
            </div>

            {delayMode === 'pattern' && (
              <div className="md:col-span-12 p-4 rounded-xl border border-gray-200 dark:border-slate-700 bg-gray-50 dark:bg-slate-900/40">
                <label className="block text-sm font-medium mb-1">Intervalos entre as mensagens (em segundos)</label>
                <p className="text-xs text-gray-500 dark:text-slate-400 mb-2">
                  Depois de cada mensagem o sistema espera o tempo da vez e, ao chegar no fim da lista, recomeça.
                  Separe por vírgula e espaço (10, 60, 40) ou ponto e vírgula; decimais com ponto ou vírgula (1.5).
                  Tudo em segundos: 1 minuto e 20 = 80.
                </p>
                <textarea
                  rows={2}
                  value={delayPatternText}
                  onChange={e => setDelayPatternText(e.target.value)}
                  placeholder="10, 60, 40, 120, 20, 60, 30, 80, 50, 15"
                  className="w-full p-2.5 border border-gray-200 rounded-xl text-sm font-mono focus:ring-2 focus:ring-green-500 outline-none"
                />
                <label className="mt-2 flex items-center gap-2 text-sm cursor-pointer">
                  <input
                    type="checkbox"
                    checked={delayShuffle}
                    onChange={e => setDelayShuffle(e.target.checked)}
                    className="accent-green-600"
                  />
                  Embaralhar a ordem a cada volta
                </label>
                {delayPatternParsed.error ? (
                  <p className="text-xs text-red-600 dark:text-red-400 mt-2">{delayPatternParsed.error}</p>
                ) : delayPatternParsed.list.length === 1 ? (
                  <p className="text-xs text-amber-600 mt-2">Informe pelo menos 2 tempos.</p>
                ) : delayPatternParsed.list.length >= 2 ? (() => {
                  const L = delayPatternParsed.list;
                  const soma = L.reduce((a, b) => a + b, 0);
                  const total = Number(totalRecipients) || 0;
                  const voltas = Math.floor(total / L.length);
                  const resto = total % L.length;
                  const totalSeg = voltas * soma + L.slice(0, resto).reduce((a, b) => a + b, 0);
                  return (
                    <div className="mt-2 text-xs text-gray-600 dark:text-slate-300 space-y-1">
                      <p className="flex flex-wrap gap-1">
                        {L.map((s, i) => (
                          <span key={i} className="px-2 py-0.5 rounded-full bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-600">{i + 1}ª: {fmtSeg(s)}</span>
                        ))}
                      </p>
                      <p>Uma volta ({L.length} mensagens): {fmtDuracao(soma)} · média de {fmtSeg(Math.round((soma / L.length) * 10) / 10)} por mensagem</p>
                      {total > 0 && <p>Para {total} destinatários: ≈ {fmtDuracao(totalSeg)}{delayShuffle ? ' (varia um pouco com a ordem embaralhada)' : ''}</p>}
                      <p className="text-gray-400 dark:text-slate-500">Estimativa mínima: o sistema aumenta o tempo sozinho se a qualidade do número ou as falhas piorarem.</p>
                    </div>
                  );
                })() : null}
              </div>
            )}
            {/* ⭐ NOVO: escolher atendentes específicos pra receber os retornos dessa campanha.
                Se ninguém for marcado, segue a regra geral do setor (compartilhada ou por %). */}
            {selectedSector && (
              <div className="md:col-span-12">
                <label className="text-sm font-medium mb-1 flex items-center gap-1.5">
                  <Users size={14} className="text-gray-400" />
                  Atendentes que vão receber os retornos (opcional — se não marcar ninguém, segue a regra do setor)
                </label>
                <div className="flex flex-wrap gap-2 p-2.5 border border-gray-200 rounded-xl">
                  {allUsers.filter(u => String(u.sector_id) === String(selectedSector) && ['attendant', 'manager'].includes(u.role)).length === 0 ? (
                    <span className="text-xs text-gray-400 px-1 py-1">Nenhum atendente nesse setor</span>
                  ) : (
                    allUsers
                      .filter(u => String(u.sector_id) === String(selectedSector) && ['attendant', 'manager'].includes(u.role))
                      .map(u => {
                        const isSelected = selectedAttendants.includes(u.id);
                        return (
                          <button
                            key={u.id}
                            type="button"
                            onClick={() => {
                              setSelectedAttendants(prev =>
                                isSelected ? prev.filter(id => id !== u.id) : [...prev, u.id]
                              );
                            }}
                            className={`px-3 py-1.5 rounded-lg text-sm font-medium border transition-colors ${
                              isSelected
                                ? 'bg-green-50 border-green-300 text-green-700'
                                : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50'
                            }`}
                          >
                            {u.name}
                          </button>
                        );
                      })
                  )}
                </div>
              </div>
            )}

            <div className="md:col-span-4">
              <label className="block text-sm font-medium mb-1">Template de Mensagem *</label>
              <select 
                value={selectedTemplate} 
                onChange={e => setSelectedTemplate(e.target.value)}
                className="w-full p-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-green-500 outline-none">
                <option value="">
                  {selectedSector ? 'Selecione um template (filtrado pelo setor)' : 'Selecione um template'}
                </option>
                {filteredTemplateList.map(t => (
                  <option key={t.id} value={t.id}>
                    {t.status === 'approved' ? '✅' : t.status === 'rejected' ? '❌' : '⏳'} {t.display_name || t.name} ({t.language || 'pt_BR'})
                  </option>
                ))}
                {selectedSector && filteredTemplateList.length === 0 && (
                  <option value="" disabled>
                    {!numberForSelectedSector || !numberForSelectedSector.waba_id
                      ? 'Esse setor ainda não tem número WhatsApp vinculado'
                      : 'Nenhum template aprovado pro WABA desse setor'}
                  </option>
                )}
              </select>
            </div>
          </div>
        </div>

   {/* Segmentação Compacta */}
<div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4">
  <h2 className="text-sm font-bold text-gray-700 flex items-center gap-2 mb-3">
    <Users size={16} className="text-blue-600"/> 
    Segmentação de Destinatários
  </h2>
  
  {campaignType !== 'with_pdfs' && (
    <>
      {/* ⭐ CORRIGIDO: setor agora só define qual número envia, não seleciona destinatários */}
      {selectedSector && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg px-3 py-2 mb-3">
          <p className="text-xs font-semibold text-blue-900">
            📞 Esse setor será usado para escolher qual número WhatsApp envia a campanha (se houver um vinculado).
          </p>
        </div>
      )}
    </>
  )}

  {/* CSV Upload */}
  <div className="border-t border-gray-100 pt-3">
    <label className="block text-xs font-medium text-gray-600 mb-2">
      {campaignType === 'with_pdfs' 
        ? 'CSV: telefone, nome, CPF'
        : 'CSV com telefones'}
    </label>
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={() => fileInputRef.current?.click()}
        className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-sm font-medium text-gray-700 transition-colors">
        <UploadCloud size={16} />
        Selecionar CSV
      </button>
      <input 
        type="file" 
        accept=".csv" 
        ref={fileInputRef} 
        onChange={handleFileChange} 
        className="hidden" 
      />
      {csvFile && (
        <div className="flex items-center gap-2 text-sm text-gray-600 flex-1">
          <FileText size={14} className="text-green-600" />
          <span className="truncate">{csvFile.name}</span>
          <span className="text-green-600 font-bold text-xs">({recipients.length})</span>
          <button onClick={() => { setCsvFile(null); setRecipients([]); }} className="text-red-500 hover:text-red-700">
            <X size={14} />
          </button>
        </div>
      )}
    </div>
  </div>
</div>
{/* Mapeamento de Variáveis */}
{selectedTemplate && csvHeaders.length > 0 && (
  <div className="bg-white rounded-xl border-2 border-purple-200 shadow-sm p-4">
    <div className="flex items-center justify-between mb-3">
      <h2 className="text-sm font-bold flex items-center gap-2 text-purple-700">
        <Database size={16} />
        Mapeamento de Variáveis
      </h2>
      <button
        type="button"
        onClick={autoMapVariables}
        className="flex items-center gap-1 px-3 py-1.5 bg-purple-100 text-purple-700 rounded-lg text-xs font-medium hover:bg-purple-200 transition-colors"
      >
        <Tag size={12} />
        Mapear Automaticamente
      </button>
    </div>
    
    <div className="space-y-2">
      {mappingVariables.map(variable => (
        <div key={variable.id} className="grid grid-cols-12 gap-2 items-center">
          <div className="col-span-5">
            <code className="text-xs font-bold text-purple-700 bg-purple-50 px-2 py-1 rounded">
              {'{{' + variable.name + '}}'}
            </code>
            <p className="text-[10px] text-gray-500 mt-0.5">{variable.description}</p>
          </div>
          <div className="col-span-1 text-center text-gray-400">→</div>
          <div className="col-span-6">
            <select
              value={variableMapping[variable.name] || ''}
              onChange={e => setVariableMapping({
                ...variableMapping,
                [variable.name]: e.target.value
              })}
              className="w-full p-1.5 border border-gray-200 rounded text-xs focus:ring-2 focus:ring-purple-500 outline-none"
            >
              <option value="">Usar valor padrão</option>
              {csvHeaders.map(header => (
                <option key={header} value={header}>{header}</option>
              ))}
            </select>
          </div>
        </div>
      ))}
    </div>
    
    <div className="mt-3 p-2 bg-blue-50 border border-blue-200 rounded-lg">
      <p className="text-xs text-blue-900">
        💡 <strong>Dica:</strong> Colunas não mapeadas usarão o valor padrão da variável
      </p>
    </div>
  </div>
)}
{/* Upload de PDFs Compacto (só aparece se campaignType === 'with_pdfs') */}
{campaignType === 'with_pdfs' && (
  <div className="bg-white rounded-xl border-2 border-purple-200 shadow-sm p-4">
    <h2 className="text-sm font-bold flex items-center gap-2 text-purple-700 mb-3">
      <FileCheck size={16} /> 
      Upload de Boletos PDF
    </h2>
    
    <div className="grid grid-cols-12 gap-3">
      {/* Info do formato */}
      <div className="col-span-5 bg-purple-50 border border-purple-200 rounded-lg p-3">
        <p className="text-xs text-purple-900 font-semibold mb-1"> Formato:</p>
        <code className="block text-[10px] font-mono text-purple-700 bg-white px-2 py-1 rounded">
          Nome_CPF_000.000.000-00.pdf
        </code>
        <p className="text-[10px] text-purple-700 mt-1">
          Ex: <code className="bg-white px-1 rounded">Joao_123.456.789-00.pdf</code>
        </p>
      </div>

      {/* Upload area */}
      <div className="col-span-7">
        <div 
          className="border-2 border-dashed border-purple-300 rounded-lg p-4 text-center cursor-pointer hover:border-purple-500 hover:bg-purple-50/30 transition-all h-full flex flex-col items-center justify-center"
          onClick={() => pdfInputRef.current?.click()}>
          <UploadCloud className="text-purple-400 mb-1" size={24} />
          <p className="text-xs text-purple-700 font-medium">Clique para selecionar PDFs</p>
          <p className="text-[10px] text-purple-500 mt-1">Até 1000 arquivos</p>
          <input 
            type="file" 
            accept=".pdf"
            multiple
            ref={pdfInputRef} 
            onChange={handlePdfChange} 
            className="hidden" 
          />
        </div>
      </div>
    </div>

    {/* Status dos PDFs */}
    {pdfFiles.length > 0 && (
      <div className="mt-3 bg-green-50 border border-green-200 rounded-lg px-3 py-2 flex items-center justify-between">
        <p className="text-xs font-bold text-green-900">
          ✅ {pdfFiles.length} PDFs selecionados
        </p>
        <button 
          onClick={() => setPdfFiles([])}
          className="text-xs text-red-600 hover:underline">
          Remover
        </button>
      </div>
    )}

    {pdfUploadResult && (
      <div className="mt-2 bg-blue-50 border border-blue-200 rounded-lg px-3 py-2">
        <p className="text-xs font-semibold text-blue-900">
          Upload: {pdfUploadResult.uploaded} ✓ | {pdfUploadResult.errors} 
        </p>
      </div>
    )}

    {matchResult && (
      <div className={`mt-2 border rounded-lg px-3 py-2 ${matchResult.errors > 0 ? 'bg-yellow-50 border-yellow-200' : 'bg-green-50 border-green-200'}`}>
        <p className="text-xs font-semibold">
          Conferência: {matchResult.matched} ✓ | {matchResult.errors} ✗
        </p>
      </div>
    )}
  </div>
)}
      </div>

      {/* Coluna Direita: Prévia + Resumo, lado a lado */}
      <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-4 items-start">
        
        {/* Prévia da Mensagem */}
        {selectedTemplateData && (
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 sticky top-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-sm font-bold text-gray-700 flex items-center gap-2">
                <Eye size={16} />
                Prévia da Mensagem
              </h3>
                            <span className={`text-xs px-2 py-1 rounded-full font-medium ${
                selectedTemplateData.status === 'approved' 
                  ? 'bg-green-100 text-green-700'
                  : selectedTemplateData.status === 'rejected'
                  ? 'bg-red-100 text-red-700'
                  : 'bg-yellow-100 text-yellow-700'
              }`}>
                {selectedTemplateData.status === 'approved' ? '✅ Aprovado' : selectedTemplateData.status === 'rejected' ? '❌ Rejeitado' : '⏳ Pendente'}
              </span>
            </div>

            {/* ⭐ NOVO: aviso forte quando o template não está pronto pra uso */}
            {selectedTemplateData.status !== 'approved' && (
              <div className="mb-4 bg-red-50 border border-red-200 rounded-xl p-3 flex items-start gap-2">
                <span className="text-red-600 flex-shrink-0">⚠️</span>
                <p className="text-xs text-red-700">
                  {selectedTemplateData.status === 'rejected'
                    ? 'Esse template foi rejeitado pela Meta e não pode ser usado. Crie um novo template.'
                    : 'Esse template ainda está aguardando aprovação da Meta. O disparo vai falhar para todos os destinatários até ele ser aprovado.'}
                </p>
              </div>
            )}
            
            {/* Preview estilo WhatsApp */}
            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm">
              {/* Header do WhatsApp */}
              <div className="bg-[#008069] text-white px-4 py-3 flex items-center gap-3">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                  <FileText size={16} />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-semibold">Soulidari</p>
                  <p className="text-xs opacity-80">Responde em alguns minutos</p>
                </div>
              </div>

              {/* Conteúdo da mensagem */}
<div className="p-4 bg-[#e5ddd5] min-h-[200px]">
  {/* Info do template */}
  <div className="bg-white rounded-lg p-3 shadow-sm mb-2">
    {/* ⭐ IMAGEM/VIDEO DO TEMPLATE — URL corrigida, sem manipulação frágil de string */}
    {selectedTemplateData.media_url || selectedTemplateData.media_path ? (
      <div className="mb-3">
        {(() => {
          const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:3001';
          const mediaFullUrl = selectedTemplateData.media_url || `${apiBase}${selectedTemplateData.media_path}`;

          if (selectedTemplateData.header_type === 'VIDEO') {
            return (
              <video 
                src={mediaFullUrl}
                controls
                className="w-full rounded-lg max-h-64"
              />
            );
          }
          if (selectedTemplateData.header_type === 'DOCUMENT') {
            return (
              <div className="bg-gray-100 rounded-lg p-4 text-center">
                <FileText size={40} className="mx-auto text-gray-400 mb-2" />
                <p className="text-xs text-gray-500">Documento PDF</p>
                <a 
                  href={mediaFullUrl}
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-xs text-blue-600 hover:underline mt-2 inline-block"
                >
                  Visualizar documento
                </a>
              </div>
            );
          }
          return (
            <img 
              src={mediaFullUrl}
              alt="Template media"
              className="w-full rounded-lg max-h-64 object-cover"
              onError={(e) => {
                console.error('❌ Erro ao carregar imagem:', { mediaFullUrl });
                e.target.style.display = 'none';
                e.target.nextElementSibling.style.display = 'flex';
              }}
            />
          );
        })()}
        
        {/* Fallback para erro de carregamento */}
        <div className="hidden bg-gray-100 rounded-lg p-4 text-center items-center justify-center">
          <FileText size={40} className="mx-auto text-gray-400 mb-2" />
          <p className="text-xs text-gray-500">Mídia não carregada</p>
        </div>
      </div>
    ) : (selectedTemplateData.components || []).find(c => c.type === 'HEADER' && c.format === 'TEXT') ? (
      <div className="mb-3">
        <div className="bg-gray-100 rounded-lg p-4 text-center">
          <FileText size={40} className="mx-auto text-gray-400 mb-2" />
          <p className="text-xs text-gray-500">
            {(selectedTemplateData.components || []).find(c => c.type === 'HEADER' && c.format === 'TEXT')?.text}
          </p>
        </div>
      </div>
    ) : null}
    
    {/* Corpo da mensagem */}
    <div className="text-sm text-gray-800 whitespace-pre-wrap">
      {preview || 'Sem preview disponível'}
    </div>
  </div>

  {/* Hora */}
  <div className="flex justify-end">
    <span className="text-xs text-gray-500">
      {new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
    </span>
  </div>
</div>
              {/* Campo de digitação */}
              <div className="bg-[#f0f2f5] px-4 py-3 flex items-center gap-3">
                <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center">
                  <span className="text-gray-600 text-xs">+</span>
                </div>
                <div className="flex-1 bg-white rounded-full px-4 py-2 text-sm text-gray-400">
                  Digite uma mensagem
                </div>
                <div className="w-8 h-8 bg-[#008069] rounded-full flex items-center justify-center">
                  <span className="text-white">🎤</span>
                </div>
              </div>
            </div>

            <p className="text-xs text-gray-500 mt-2">
              💡 Variáveis como {'{{1}}'} serão substituídas automaticamente
            </p>
          </div>
        )}

        {/* Resumo do Disparo */}
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 sticky top-6">
          <h3 className="font-bold text-gray-900 mb-4">Resumo do Disparo</h3>
          <div className="space-y-3 mb-6">
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Tipo:</span>
              <span className="font-medium">
                {campaignType === 'text' ? '📝 Texto' : '📄 Texto + PDF'}
              </span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Template:</span>
              <span className="font-medium truncate ml-2 max-w-[150px]">
                {selectedTemplateData ? (selectedTemplateData.display_name || selectedTemplateData.name) : '—'}
              </span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Destinatários:</span>
              <span className="font-medium text-green-600">{totalRecipients}</span>
            </div>
            {campaignType === 'with_pdfs' && (
              <div className="flex justify-between text-sm">
                <span className="text-gray-500">PDFs:</span>
                <span className="font-medium text-purple-600">{pdfFiles.length}</span>
              </div>
            )}
          </div>

          {/* ⭐ NOVO: Enviar agora ou Agendar pra depois (igual WATI) */}
          <div className="mb-4">
            <div className="grid grid-cols-2 gap-2 mb-2">
              <button
                type="button"
                onClick={() => setSendMode('now')}
                className={`py-2 rounded-xl text-sm font-bold border-2 transition-all ${
                  sendMode === 'now' ? 'border-green-500 bg-green-50 text-green-700' : 'border-gray-200 text-gray-500'
                }`}
              >
                Enviar agora
              </button>
              <button
                type="button"
                onClick={() => setSendMode('schedule')}
                className={`py-2 rounded-xl text-sm font-bold border-2 transition-all ${
                  sendMode === 'schedule' ? 'border-blue-500 bg-blue-50 text-blue-700' : 'border-gray-200 text-gray-500'
                }`}
              >
                Agendar
              </button>
            </div>
            {sendMode === 'schedule' && (
              <div className="relative">
                <button
                  type="button"
                  onClick={() => setShowCalendar(v => !v)}
                  className="w-full flex items-center gap-2 p-2.5 border border-gray-200 rounded-xl text-sm text-left focus:ring-2 focus:ring-blue-500 outline-none"
                >
                  <CalendarDays size={16} className="text-gray-400 flex-shrink-0" />
                  <span className={scheduledAt ? 'text-gray-900' : 'text-gray-400'}>{formatScheduledDisplay()}</span>
                </button>

                {showCalendar && (
                  <div className="absolute z-20 mt-2 w-72 bg-white border border-gray-200 rounded-xl shadow-lg p-3">
                    {/* Cabeçalho: mês/ano + navegação */}
                    <div className="flex items-center justify-between mb-2">
                      <button
                        type="button"
                        onClick={() => setCalendarMonth(new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() - 1, 1))}
                        className="p-1 hover:bg-gray-100 rounded-lg"
                      >
                        <ChevronLeft size={16} />
                      </button>
                      <span className="text-sm font-bold capitalize">
                        {calendarMonth.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })}
                      </span>
                      <button
                        type="button"
                        onClick={() => setCalendarMonth(new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() + 1, 1))}
                        className="p-1 hover:bg-gray-100 rounded-lg"
                      >
                        <ChevronRight size={16} />
                      </button>
                    </div>

                    {/* Dias da semana */}
                    <div className="grid grid-cols-7 gap-1 mb-1">
                      {['D', 'S', 'T', 'Q', 'Q', 'S', 'S'].map((d, i) => (
                        <div key={i} className="text-center text-[10px] font-bold text-gray-400">{d}</div>
                      ))}
                    </div>

                    {/* Grade de dias */}
                    <div className="grid grid-cols-7 gap-1">
                      {getCalendarDays(calendarMonth).map((day, idx) => {
                        if (!day) return <div key={idx} />;
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);
                        const isPast = day < today;
                        const isSelected = scheduledAt && scheduledAt.startsWith(
                          `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`
                        );
                        return (
                          <button
                            key={idx}
                            type="button"
                            disabled={isPast}
                            onClick={() => selectCalendarDay(day)}
                            className={`text-xs py-1.5 rounded-lg transition-colors ${
                              isPast
                                ? 'text-gray-300 cursor-not-allowed'
                                : isSelected
                                ? 'bg-blue-600 text-white font-bold'
                                : 'text-gray-700 hover:bg-blue-50'
                            }`}
                          >
                            {day.getDate()}
                          </button>
                        );
                      })}
                    </div>

                    {/* Horário */}
                    <div className="flex items-center gap-2 mt-3 pt-3 border-t border-gray-100">
                      <Clock size={14} className="text-gray-400" />
                      <input
                        type="time"
                        value={scheduledTime}
                        onChange={e => updateScheduledTime(e.target.value)}
                        className="flex-1 p-1.5 border border-gray-200 rounded-lg text-sm outline-none"
                      />
                      <button
                        type="button"
                        onClick={() => setShowCalendar(false)}
                        className="px-3 py-1.5 bg-blue-600 text-white rounded-lg text-xs font-bold"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          <button 
            onClick={handleSubmit}
            disabled={!campaignName || !selectedTemplate || totalRecipients === 0 || sending || selectedTemplateData?.status !== 'approved' || (sendMode === 'schedule' && !scheduledAt)}
            className={`w-full flex items-center justify-center gap-2 px-6 py-3 text-white rounded-xl font-bold disabled:opacity-50 disabled:cursor-not-allowed shadow-lg transition-all ${
              sendMode === 'schedule'
                ? 'bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 shadow-blue-100'
                : 'bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 shadow-green-100'
            }`}>
            {sending ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                Processando...
              </>
            ) : sendMode === 'schedule' ? (
              <>
                <Clock size={20} />
                Agendar Disparo
              </>
            ) : (
              <>
                <Send size={20} /> 
                Iniciar Disparo
              </>
            )}
          </button>

          {totalRecipients > 0 && (
            <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-xl">
              <p className="text-xs text-yellow-800">
                <strong>⚠️ Atenção:</strong> O envio respeita o limite da Meta (~1 mensagem/segundo). 
                Para {totalRecipients} contatos, pode levar aproximadamente {Math.ceil(totalRecipients / 60)} minutos.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);
}

export default BulkMessaging;

